// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WFjHU","largestCol":"styles_largestCol__2oeDA","smallestCol":"styles_smallestCol__3ycYv"};